"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.container = void 0;

var _util = require("../../../util");

const container = ({
  theme
}) => ({
  backgroundColor: (0, _util.color)(theme, 'interactive.ticker.default'),
  height: 48,
  width: 48
});

exports.container = container;
//# sourceMappingURL=MarketSummaryButton.style.js.map